import isServer from '@/src/utils/isServer';

export const getWindowObject = () => (isServer() ? null : window);
